const FilterOperations = {
  GreaterThan: 'gt',
  GreaterOrEqualThan: 'gte',
  LessThan: 'lt',
  LessOrEqualThan: 'lte',
  Equals: 'eq',
  Like: 'like',
  In: 'in',
  ILike: 'ilike',
};

Object.freeze(FilterOperations);

const FilterComponentNames = {
  TextComponent: 'text',
  DatepickerComponent: 'datepicker',
  DropdownComponent: 'dropdown',
  UserDropdownComponent: 'userDropdown',
};

Object.freeze(FilterComponentNames);

export { FilterOperations, FilterComponentNames };
